import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { SUPPORTED_LANGUAGES, type Language } from '@/entities/preferences/model/schema';
import trCommon from './locales/tr-TR/common.json';
import trApp from './locales/tr-TR/app.json';
import enCommon from './locales/en-US/common.json';
import enApp from './locales/en-US/app.json';
import deCommon from './locales/de-DE/common.json';
import deApp from './locales/de-DE/app.json';
import frCommon from './locales/fr-FR/common.json';
import frApp from './locales/fr-FR/app.json';
import itCommon from './locales/it-IT/common.json';
import itApp from './locales/it-IT/app.json';
import ruCommon from './locales/ru-RU/common.json';
import ruApp from './locales/ru-RU/app.json';

export const resources = {
  'tr-TR': { common: trCommon, app: trApp },
  'en-US': { common: enCommon, app: enApp },
  'de-DE': { common: deCommon, app: deApp },
  'fr-FR': { common: frCommon, app: frApp },
  'it-IT': { common: itCommon, app: itApp },
  'ru-RU': { common: ruCommon, app: ruApp },
} as const;

export function normalizeLanguage(input: string | null | undefined): Language {
  if (!input) return 'tr-TR';
  const exact = SUPPORTED_LANGUAGES.find((l) => l.toLowerCase() === input.toLowerCase());
  if (exact) return exact;
  const prefix = input.slice(0, 2).toLowerCase();
  return SUPPORTED_LANGUAGES.find((l) => l.startsWith(prefix)) ?? 'tr-TR';
}

export async function initI18n(language: Language) {
  if (i18n.isInitialized) {
    if (i18n.language !== language) await i18n.changeLanguage(language);
    return i18n;
  }
  await i18n.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: 'tr-TR',
    supportedLngs: [...SUPPORTED_LANGUAGES],
    ns: ['app', 'common'],
    defaultNS: 'app',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
  return i18n;
}

export { SUPPORTED_LANGUAGES };
export const LANGUAGE_LABELS: Record<Language, string> = {
  'tr-TR': 'Türkçe',
  'en-US': 'English',
  'de-DE': 'Deutsch',
  'fr-FR': 'Français',
  'it-IT': 'Italiano',
  'ru-RU': 'Русский',
};
export default i18n;
